module.exports = __webpack_public_path__ + "img/account-manage-info.2c0aee1f.svg";